import * as types from './types'
export default {
  [types.RESET_LOOKUPS](state) {
    state.lookups = {}
  },
  [types.RESET_INSURANCE_DATA](state) {
    state.insurance = []
    state.sourceInsurance = []
    state.insuranceLookup = []
    state.selectedInsurance = null
    state.newInsurance = {
      insurance: null,
      insuranceName: null,
      firm: 1,
      isInactive: false
    }
  },
  [types.SET_INSURANCE_DATA](state, data) {
    switch (data.name) {
      case 'data':
        state.insurance = data.value
        break
      case 'reset':
        state.search = ''
        // for some reason, the following is extremely slow during render (not sure why)
        // this.insurance = []
        // this.insurance = JSON.parse(JSON.stringify(this.sourceInsurance))
        break
      case 'add':
        state.newInsurance = {
          insurance: null,
          insuranceName: null,
          firm: 1,
          isInactive: false
        }
        break
      case 'selected': {
        state.selectedInsurance = null
        state.insuranceLookup = []
        state.insurance.forEach((element) => {
          element.isSelected = false
        })
        let found = state.insurance.find((x) => parseInt(x.insuranceContact) === parseInt(data.value))
        if (found) {
          state.selectedInsurance = found.insuranceContact
          found.isSelected = true
        }
        break
      }
      case 'search': {
        state.search = data.value.trim()
        if (state.search !== '') {
          state.insurance = []
          state.insurance = state.sourceInsurance.filter((element) => element.insuranceName.toLowerCase().includes(state.search.toLowerCase()))
        }
        break
      }
      case 'name':
        state.newInsurance.insuranceName = data.value
        break
      case 'inactive':
        state.selectedInsurance.isInactive = data.value
        break
    }
  },
  [types.SET_LOOKUPS](state, [keys, lookups, showIsactive]) {
    let _lookups = {}
    for (let key of keys) {
      _lookups[key] = []
      if (lookups !== undefined && lookups !== null) {
        for (let lookup of lookups) {
          if (lookup.key === key) {
            lookup.type1 = lookup.code || null
            lookup.type2 = lookup.name || null
            lookup.type3 = lookup.type3 || null
            lookup.name = lookup.value || lookup.name
            lookup.value = lookup.id
            lookup.isInactive = showIsactive
            _lookups[key].push(lookup)
          }
        }
      }
    }
    state.lookups = JSON.parse(JSON.stringify(Object.assign(state.lookups, _lookups)))
  },
  [types.SET_KEYWORDS](state, [data]) {},
  [types.UPSERT_LOOKUP](state, [lookup, id]) {
    lookup.id = id
    let section = state.groups.filter((group) => group.sectionName === lookup.section)
    if (section.length > 0) {
      let index = section[0].children.findIndex((i) => i.id === lookup.id)
      if (index >= 0) {
        section[0].children[index] = lookup
      } else {
        section[0].children.push(lookup)
      }
    }
  },
  [types.DELETE_LOOKUP](state, lookup) {
    try {
      let section = state.groups.filter((group) => group.sectionName === lookup.section)
      if (section.length > 0) {
        let index = section[0].children.findIndex((i) => i.id === lookup.id)
        section[0].children.splice(index, 1)
      }
    } catch (e) {}
  },
  [types.SET_GROUPS](state, groups) {
    state.groups = groups
  },
  [types.UPSERT_GROUP](state, data) {
    let group = state.groups.filter((g) => g.id === data.id)
    if (group.length > 0) {
      group[0].sectionName = data.text
    }
  },
  [types.SET_COUNTRIES](state, data) {
    state.countries = data
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.countries = JSON.parse(JSON.stringify(Object.assign(state.countries, _items)))
  },
  [types.SET_TIMEZONES](state, data) {
    state.timeZones = []
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.timeZones = JSON.parse(JSON.stringify(Object.assign(state.timeZones, _items)))
  },
  [types.SET_STATE_PROVINCES](state, data) {
    state.stateProvinces = []
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.stateProvinces = JSON.parse(JSON.stringify(Object.assign(state.stateProvinces, _items)))
    if (state.lookups['StateProvince'] !== undefined && state.lookups['StateProvince'] !== null) {
      state.lookups['StateProvince'] = state.stateProvinces
    }
  },
  [types.SET_LANGUAGES](state, data) {
    state.languages = []
    let _items = []
    for (let item of data) {
      item.value = parseInt(item.id)
      _items.push(item)
    }
    state.languages = JSON.parse(JSON.stringify(Object.assign(state.languages, _items)))
  },
  [types.SET_BRAND](state, data) {
    state.brand = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        console.log('Got Brand', data)
        state.brand = data
      }
    }
  },
  [types.SET_INSURANCE](state, data) {
    if (data) {
      state.selectedInsurance = null
      state.insuranceLookup = []
      state.sourceInsurance = []
      state.insurance = []
      state.sourceInsurance = data
      state.sourceInsurance.forEach((element) => {
        element.isSelected = false
      })
      state.insurance = JSON.parse(JSON.stringify(state.sourceInsurance))
    }
  },
  [types.SET_INSURANCE_LOOKUP](state, data) {
    state.insuranceLookup = []
    if (data) {
      state.insuranceLookup = data
      if (state.insuranceLookup === null || state.insuranceLookup.length === 0) {
        state.insuranceLookup = []
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/mutations.js